export class Empresa {
	id: number;
	razonSocial: string;
	cuit: string;

	constructor(data = null) {
		if (data) {
			this.id = data.idEmpresa;
			this.razonSocial = data.razonSocial;
			this.cuit = data.cuit
				? data.cuit
				: data.nroDocumento && data.tipoDocumento.abrev == 'CUIT'
				? data.nroDocumento
				: '';
		}
	}
}
